// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(error) {
  switch (error) {
    case "GPS Error" :
        return /* GPSError */4;
    case "No Error" :
        return /* NoError */0;
    case "No GPS Locations Error" :
        return /* NoGPSLocationsError */3;
    case "Server Error" :
        return /* ServerError */1;
    case "Trip Started Time Nil Error" :
        return /* TripStartedTimeNilError */2;
    default:
      return ErrorUtils$Catalyst.raiseError("OrderFareType.res", "Invalid Order Fare Error", error);
  }
}

function toString(error) {
  switch (error) {
    case /* NoError */0 :
        return "No Error";
    case /* ServerError */1 :
        return "Server Error";
    case /* TripStartedTimeNilError */2 :
        return "Trip Started Time Nil Error";
    case /* NoGPSLocationsError */3 :
        return "No GPS Locations Error";
    case /* GPSError */4 :
        return "GPS Error";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
